import { Controller } from "@hotwired/stimulus"

// 投稿チェックの一括操作用コントローラー
export default class extends Controller {
  static targets = ["checkbox", "selectAll"]

  // 全選択/全解除
  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
  }

  // 個別チェックボックスの状態変更時に全選択チェックボックスを更新
  updateSelectAll() {
    const allChecked = this.checkboxTargets.every(checkbox => checkbox.checked)
    this.selectAllTarget.checked = allChecked
  }

  // SFのみ案件の送信
  submitSalesforce(event) {
    event.preventDefault()

    const selectedIds = this.getSelectedIds('salesforce')

    if (selectedIds.length === 0) {
      alert('SFのみ案件を1つ以上選択してください')
      return false
    }

    if (confirm(`選択したSFのみ案件（${selectedIds.length}件）をサイトに登録しますか？`)) {
      this.submitForm('salesforce_form', selectedIds)
    }
  }

  // サイト記事のみ案件の送信
  submitApp(event) {
    event.preventDefault()

    const selectedIds = this.getSelectedIds('app')

    if (selectedIds.length === 0) {
      alert('サイト記事のみ案件を1つ以上選択してください')
      return false
    }

    if (confirm(`選択したサイト記事のみ案件（${selectedIds.length}件）を削除しますか？`)) {
      this.submitForm('app_form', selectedIds)
    }
  }

  // 選択されたIDを取得
  getSelectedIds(source) {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked && checkbox.dataset.source === source)
      .map(checkbox => checkbox.value)
  }

  // フォーム送信
  submitForm(formId, ids) {
    const form = document.getElementById(formId)

    // 既存のhidden inputを削除
    form.querySelectorAll('input[name="discrepancy_ids[]"]').forEach(input => input.remove())

    // 選択されたIDをhidden inputとして追加
    ids.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'discrepancy_ids[]'
      input.value = id
      form.appendChild(input)
    })

    form.submit()
  }
}
